/**
 * Gestión del tab de configuración del catálogo
 * Archivo: configuration-tab.js
 * Versión: 5 - 2026-02-09 - Producción (logs limpios finales)
 */

// Variables globales para el tab de configuración
let selectedImage = null;
let configurationData = {};

// Funciones principales
function initializeConfiguration() {
    loadStoredConfiguration();
    setupImageSelection();
    setupFormHandling();
    setupButtons();
}

// Cargar configuración guardada
function loadStoredConfiguration() {
    try {
        const stored = localStorage.getItem('configuration');
        if (stored) {
            configurationData = JSON.parse(stored);
            restoreFormData();
            restoreSelectedImage();
        }
    } catch (error) {
        console.error('Error loading configuration:', error);
        localStorage.removeItem('configuration');
    }
}

// Restaurar datos del formulario
function restoreFormData() {
    const inputs = document.querySelectorAll('.configuration-input');
    inputs.forEach(function (input) {
        if (configurationData[input.name]) {
            input.value = configurationData[input.name];
        }
    });
}

// Restaurar imagen seleccionada
function restoreSelectedImage() {
    if (configurationData.featured_image) {
        selectedImage = configurationData.featured_image;
        highlightSelectedImage(configurationData.featured_image.id);
    }
}

// Configurar selección de imágenes
function setupImageSelection() {
    const imageContainer = document.querySelector('#featured-image-container');
    if (!imageContainer) return;

    const images = imageContainer.querySelectorAll('.prod-check-card');

    images.forEach(function (imageElement) {
        imageElement.addEventListener('click', function () {
            handleImageSelection(imageElement);
        });
    });
}

// Manejar selección de imagen
function handleImageSelection(imageElement) {
    try {
        const imageEl = imageElement.querySelector('img');
        const imageSrc = imageEl ? imageEl.getAttribute('src') : null;

        if (!imageSrc) {
            return;
        }

        selectedImage = {
            src: normalizeImageUrl(imageSrc),
            id: imageElement.id,
            alt: imageEl.getAttribute('alt') || ''
        };

        highlightSelectedImage(imageElement.id);
    } catch (error) {
        console.error('Error seleccionando imagen:', error);
    }
}

// Resaltar imagen seleccionada
function highlightSelectedImage(imageId) {
    // Remover selección previa
    const images = document.querySelectorAll('#featured-image-container .prod-check-card');
    images.forEach(function (img) {
        img.classList.remove('selected');
    });

    // Agregar selección actual
    const selectedElement = document.getElementById(imageId);
    if (selectedElement) {
        selectedElement.classList.add('selected');
    }
}

// Normalizar URL de imagen
function normalizeImageUrl(imageSrc) {
    const shopURL = window.SHOP_URL || '';
    try {
        const url = new URL(shopURL);
        return imageSrc.includes(url.hostname) ? 'https:' + imageSrc : shopURL + imageSrc;
    } catch (error) {
        console.warn('Error normalizando URL:', error);
        return imageSrc;
    }
}

// Configurar manejo del formulario
function setupFormHandling() {
    const inputs = document.querySelectorAll('.configuration-input');

    inputs.forEach(function (input) {
        input.addEventListener('change', function () {
            saveConfiguration();
        });
    });
}

// Configurar botones
function setupButtons() {
    setupContinueButton();
    setupBackButton();
    setupModal();
}

// Configurar botón continuar
function setupContinueButton() {
    let continueButton;
    try {
        continueButton = document.querySelector('#continue-button');
    } catch (error) {
        console.error('Error buscando continue button:', error);
        return;
    }

    if (continueButton) {
        try {
            continueButton.removeAttribute('onclick');
            continueButton.setAttribute('href', 'javascript:void(0);');

            // Usar capturing phase para interceptar antes
            continueButton.addEventListener('click', function (event) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();

                handleConfigurationContinueClick();
                return false;
            }, true); // <-- capturing phase
        } catch (error) {
            console.error('Error configurando continue button:', error);
        }
    } else {
        console.error('Continue button NO encontrado');
    }

}

// Configurar botón volver
function setupBackButton() {
    const backButton = document.querySelector('#back-to-selection');

    if (backButton) {
        backButton.removeAttribute('onclick');
        backButton.setAttribute('href', 'javascript:void(0);');

        backButton.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            const selectionTab = document.querySelector("[data-w-tab='Product Selection']");
            if (selectionTab) selectionTab.click();

            return false;
        }, true); // <-- capturing phase
    } else {
        console.error('Back button NO encontrado');
    }
}

// Manejar click en continuar
function handleConfigurationContinueClick() {
    const validation = validateConfiguration();

    const modal = document.querySelector('#configuration-comfirm-modal');

    if (!modal) {
        console.error('Modal no encontrado');
        return;
    }

    modal.classList.remove('catalog-modal-wrap');

    if (!validation.isValid) {
        showValidationError(validation.message);
        return;
    }

    showConfirmationModal();
}

// Validar configuración
function validateConfiguration() {
    const inputs = document.querySelectorAll('.configuration-input');
    const emptyInputs = [];

    inputs.forEach(function (input) {
        if (input.type !== 'hidden' && !input.value.trim()) {
            emptyInputs.push(input);
        }
    });

    if (emptyInputs.length > 0) {
        return {
            isValid: false,
            message: 'Please fill all required fields to continue.'
        };
    }

    if (!selectedImage) {
        return {
            isValid: false,
            message: 'Please select a featured image for your catalog.'
        };
    }

    return { isValid: true };
}

// Mostrar error de validación
function showValidationError(message) {
    const modalTitle = document.querySelector('#configuration-comfirm-modal #modal-title');
    const modalText = document.querySelector('#configuration-comfirm-modal #modal-text');
    const confirmButton = document.querySelector('#configuration-comfirm-modal .continue-modal');

    if (modalTitle) modalTitle.textContent = 'Missing Information';
    if (modalText) modalText.textContent = message;
    if (confirmButton) confirmButton.style.display = 'none';
}

// Mostrar modal de confirmación
function showConfirmationModal() {
    const modalTitle = document.querySelector('#configuration-comfirm-modal #modal-title');
    const modalText = document.querySelector('#configuration-comfirm-modal #modal-text');
    const confirmButton = document.querySelector('#configuration-comfirm-modal .continue-modal');

    if (modalTitle) modalTitle.textContent = window.CONFIG_MODAL_TITLE || 'Confirm Configuration';
    if (modalText) modalText.textContent = window.CONFIG_MODAL_TEXT || 'Continue with this configuration?';
    if (confirmButton) confirmButton.style.display = 'flex';
}

// Configurar modal
function setupModal() {
    const modal = document.querySelector('#configuration-comfirm-modal');
    const confirmButton = document.querySelector('#configuration-comfirm-modal .continue-modal');
    const closeButtons = document.querySelectorAll('#configuration-comfirm-modal .close-modal');

    // Botón confirmar
    if (confirmButton) {
        confirmButton.addEventListener('click', function (event) {
            event.preventDefault();

            const finalConfig = buildConfiguration();
            saveConfiguration(finalConfig);

            modal.classList.add('catalog-modal-wrap');

            // Ir al tab de resumen
            const summaryTab = document.querySelector("[data-w-tab='Catalog Summary']");
            if (summaryTab) {
                summaryTab.click();

                // Actualizar resumen con nueva configuración
                const products = JSON.parse(localStorage.getItem('selectedProducts') || '[]');
                if (window.setDataInSummary) {
                    window.setDataInSummary(finalConfig, products);
                }
            }
        });
    }

    // Botones cerrar
    closeButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
            event.preventDefault();
            modal.classList.add('catalog-modal-wrap');
        });
    });
}

// Construir objeto de configuración
function buildConfiguration() {
    const config = {};
    const inputs = document.querySelectorAll('.configuration-input');

    inputs.forEach(function (input) {
        config[input.name] = input.value;
    });

    if (selectedImage) {
        config.featured_image = selectedImage;
    }

    return config;
}

// Guardar configuración
function saveConfiguration(config) {
    const dataToSave = config || buildConfiguration();

    try {
        localStorage.setItem('configuration', JSON.stringify(dataToSave));
        configurationData = dataToSave;
    } catch (error) {
        console.error('Error saving configuration:', error);
    }
}

// Función para reinicializar cuando el tab se activa
function reinitializeConfiguration() {
    setupImageSelection();
    loadStoredConfiguration();
}

// Inicializar cuando el DOM esté listo (una sola vez)
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
        setTimeout(function () {
            initializeConfiguration();
        }, 100);
    });
} else {
    // DOM ya cargado
    setTimeout(function () {
        initializeConfiguration();
    }, 100);
}

// Función de debugging manual
window.debugConfigurationTab = function () {
    console.log('=== DEBUG CONFIGURATION TAB ===');
    console.log('Continue button:', document.querySelector('#continue-button'));
    console.log('Back button:', document.querySelector('#back-to-selection'));
    console.log('Modal:', document.querySelector('#configuration-comfirm-modal'));
    console.log('Selected image:', selectedImage);
    console.log('Configuration data:', configurationData);

    // Debugging del DOM
    console.log('=== DOM DEBUGGING ===');
    console.log('Todos los botones:', document.querySelectorAll('button, .btn').length);
    console.log('Elementos con ID continue:', document.querySelectorAll('[id*="continue"]'));
    console.log('Tab activo:', document.querySelector('.w--tab-active'));

    // Buscar por diferentes métodos
    console.log('=== BÚSQUEDA DE BOTÓN ===');
    const methods = [
        '#continue-button',
        'button[id="continue-button"]',
        '[id="continue-button"]'
    ];

    methods.forEach(method => {
        try {
            const result = document.querySelector(method);
            console.log(`Método "${method}":`, result);
        } catch (e) {
            console.log(`Método "${method}" falló:`, e.message);
        }
    });

    // Re-ejecutar setup
    console.log('=== RE-EJECUTANDO SETUP ===');
    setupButtons();
};

// Función para forzar configuración manual
window.forceConfigurationSetup = function () {
    console.log('=== CONFIGURACIÓN FORZADA ===');
    const btn = document.querySelector('#continue-button');
    if (btn) {
        btn.onclick = function (e) {
            e.preventDefault();
            console.log('Click forzado detectado en continue!');
            handleContinueClick();
            return false;
        };
        console.log('Botón configurado con onclick manual');
    } else {
        console.log('Botón no encontrado para configuración forzada');
    }
};

// Exportar funciones para uso externo
window.ConfigurationTab = {
    initialize: initializeConfiguration,
    reinitialize: reinitializeConfiguration,
    getConfiguration: function () { return configurationData; },
    clearConfiguration: function () {
        configurationData = {};
        selectedImage = null;
        localStorage.removeItem('configuration');
    }
};